import { axiosAuth } from "common/api/axios/auth_axios";
import { axiosCitajteo } from "common/api/axios/citajteo_axios";

export type AuthResponse = {
  un: string;
  uType: string;
};

export type AuthLoginParams = {
  un: string;
  pw: string;
};

export const authCurrentGet = async (): Promise<AuthResponse> => {
  let authResponse: AuthResponse = { un: "", uType: "" };
  const { data } = await axiosCitajteo.get("auth/l-current", {
    withCredentials: true,
  });
  authResponse = { ...data };

  return authResponse;
};

export const authLogin = async (
  loginParams: AuthLoginParams
): Promise<boolean> => {
  let success: boolean = false;
  let response: any;
  try {
    response = await axiosCitajteo.post("auth/l-in", loginParams, {
      withCredentials: true,
    });
  } catch (error) {}
  if (response && response.status === 200) {
    success = true;
  }

  return success;
};

export const authLogout = async (): Promise<boolean> => {
  let success: boolean = false;
  let response: any;
  try {
    response = await axiosCitajteo.post(
      "auth/l-out",
      {},
      { withCredentials: true }
    );
  } catch (error) {}
  if (response && response.status === 200) {
    success = true;
  }

  return success;
};
